module.exports = __webpack_public_path__ + "static/media/fanzhh_zhifubao_shoukuan.537cad14.png";


//////////////////
// WEBPACK FOOTER
// ./src/fanzhh_zhifubao_shoukuan.png
// module id = 674
// module chunks = 0